import React from 'react';
import { NavLink } from 'react-router-dom';
import { Tag } from 'antd';
import CourseObj from '../objects/courseType';
import RenderDelete from '../view/components/table/RenderDelete';

const renderCourseType = (courseType, record) => {
  const normalizedCourseType = courseType === 'LECTURE' ? 'MIN60' : courseType;
  const target = CourseObj.courseType.find(
    (item) => item.type === normalizedCourseType
  );
  if (target) {
    return <Tag color={target.color}>{target.name}</Tag>;
  }

  return normalizedCourseType ? (
    <Tag color='green'>{normalizedCourseType}</Tag>
  ) : null;
};

const columns = [
  {
    title: '名字',
    dataIndex: 'studentName',
    key: 'studentName',
    render: (text, record, index) => {
      return <NavLink to={`/student/${record.student}`}>{text}</NavLink>;
    },
  },
  {
    title: '上课老师',
    dataIndex: 'teacherName',
    key: 'teacherName',
  },
  {
    title: '课程类别名称',
    dataIndex: 'courseTypeDisplayName',
    key: 'courseTypeDisplayName',
  },
  {
    title: '类型',
    dataIndex: 'courseType',
    key: 'courseType',
    render: (courseType, record) => renderCourseType(courseType, record),
  },
  {
    title: '日期',
    dataIndex: 'feedbackDate',
    key: 'feedbackDate',
    responsive: ['lg'],
  },
  {
    title: '内容',
    dataIndex: 'content',
    key: 'content',
    responsive: ['lg'],
  },
  {
    title: '结课提醒',
    dataIndex: 'courseEndReminder',
    key: 'courseEndReminder',
    render: (text) => (text ? <Tag color='orange'>{text}</Tag> : null),
  },
  {
    title: '操作',
    key: 'operation',
    fixed: 'right',
    width: 100,
    render: (record) => <RenderDelete record={record} />,
  },
];

export default { columns };
